// Calcule le pourcentage de vidéo regardé
export function getWatchedPercentage(watchTime: number, duration: number): number {
  if (!duration || duration <= 0) return 0;

  return Math.round((watchTime / duration) * 100);
}
